"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NgLifeCycleLog = void 0;
/**
 * Class Decorator: Logs life-cycle method calls and their arguments
 * ```
 * \@NgLifeCycleLog()
 * export class myClass() {
 *  ...
 * }
 * ```
 */
// eslint-disable-next-line id-blacklist
function NgLifeCycleLog() {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function (constructor) {
        const LIFE_CYCLE_HOOKS = ["ngOnInit", "ngOnChanges", "ngOnDestroy"];
        const componentName = constructor.name;
        LIFE_CYCLE_HOOKS.forEach((hook) => {
            const original = constructor.prototype[hook];
            constructor.prototype[hook] = function (...args) {
                // eslint-disable-next-line no-console
                console.log(`%c ${componentName} - ${hook}`, "color: #4CAF50; font-weight: bold", ...args);
                original && original.apply(this, args);
            };
        });
    };
}
exports.NgLifeCycleLog = NgLifeCycleLog;
